import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { RootState } from '../store'
import dayjs from 'dayjs'

export interface MonthPickerState {
  selectedDate: string
  dailyDate: string
}

const initialState: MonthPickerState = {
  selectedDate: '',
  dailyDate: '',
}

export const monthPickerSlice = createSlice({
  name: 'monthPicker',
  initialState,
  reducers: {
    setDate: (state, action: PayloadAction<string>) => {
      state.selectedDate = action.payload.toString()
    },
    setDailyDate: (state, action: PayloadAction<string>) => {
      state.dailyDate = action.payload.toString()
    },
    increaseMonth: state => {
      state.selectedDate = dayjs(state.selectedDate).add(1, 'month').toString()
    },
    decreaseMonth: state => {
      state.selectedDate = dayjs(state.selectedDate).subtract(1, 'month').toString()
    },
    increaseDay: state => {
      state.selectedDate = dayjs(state.selectedDate).add(1, 'day').toString()
    },
    decreaseDay: state => {
      state.selectedDate = dayjs(state.selectedDate).subtract(1, 'day').toString()
    },
    increaseWeek: state => {
      state.selectedDate = dayjs(state.selectedDate).add(1, 'week').toString()
    },
    decreaseWeek: state => {
      state.selectedDate = dayjs(state.selectedDate).subtract(1, 'week').toString()
    },
    increaseYear: state => {
      state.selectedDate = dayjs(state.selectedDate).add(1, 'year').toString()
    },
    decreaseYear: state => {
      state.selectedDate = dayjs(state.selectedDate).subtract(1, 'year').toString()
    },
    increaseDailyDay: state => {
      state.dailyDate = dayjs(state.dailyDate).add(1, 'day').toString()
    },
    decreaseDailyDay: state => {
      state.dailyDate = dayjs(state.dailyDate).subtract(1, 'day').toString()
    },
  },
})

export const getSelectedDate = (state: RootState) => state.monthPicker.selectedDate
export const getDailyDate = (state: RootState) => state.monthPicker.dailyDate

export const monthPickerActions = monthPickerSlice.actions
export const monthPickerReducer = monthPickerSlice.reducer
